// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nsvg[data-v-6d26418c]{\n  filter: drop-shadow(0 0 0.75rem #171717);\n}\n.st0[data-v-6d26418c]{\n  fill: #72bf44;\n  width: 30px;\n}\n.st1[data-v-6d26418c]{\n  fill:none;stroke:#002C50;stroke-width:60;stroke-miterlimit:10;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
